import MainSkills from "../../components/Forms/MainSkills";
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";
import CreateTrainingForm from "../../components/Forms/CreateTrainingForm";

function CreateTraining() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <CreateTrainingForm/>
            </BasicCard>
        </>
    )
}
export default CreateTraining;